export default "__VITE_ASSET__5Hp_$Ktk__"